import React, { useEffect, useState } from 'react'
// import logoSC from "../Imagenes/logoSCTKD.png"

import { Typography, Button, Paper, Modal } from '@material-ui/core';
import { useNavigate } from "react-router"
import { makeStyles } from '@material-ui/styles';
import logoSC from "../Imagenes/logoSCTKD.webp"
import compBg from "../Imagenes/comp-bg.webp"
import { useLocation } from 'react-router-dom';
import { CircularProgress, useThemeProps } from '@mui/material';
import EliminacionDirecta from './llaves/EliminacionDirecta.js'
import Grupos from './llaves/Grupos.js';
import Salto from './llaves/Salto.js';

const Styles = makeStyles({
  root: {
    position: "relative",
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#0a0d14",
    overflowX: "hidden",
    boxSizing: "border-box",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  bg: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${compBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    opacity: 0.25,
    zIndex: 0
  },
  content: {
    position: "relative",
    zIndex: 1,
    width: "100%"
  },
  header: {
    width: "calc(100% - 32px)",
    maxWidth: 360,
    margin: "16px auto",
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px",
    backgroundColor: "rgba(20, 24, 33, 0.65)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: 16,
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    boxSizing: "border-box"
  },
  logologo: {
    width: 70,
    height: "auto",
    objectFit: "contain",
    flexShrink: 0,
    cursor: "pointer",
    transition: "transform 0.2s ease",
    "&:active": {
      transform: "scale(0.95)"
    }
  },
  disciplina: {
    color: "#ffffff",
    fontWeight: 800,
    fontStyle: "italic",
    textTransform: "uppercase",
    letterSpacing: 1,
    fontSize: 20,
    textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "@media (max-width: 600px)": {
      fontSize: 16
    }
  },
  llavesScroll: {
    width: "100%",
    overflowX: "auto",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
  }
})

const LlavesHome = () => {


  const { state } = useLocation();
  const navigate = useNavigate()
  const [medidas, setMedidas] = useState("auto");
  const [datos, setDatos] = useState(Array.isArray(state) ? state : state?.llave);
  const compId = Array.isArray(state) ? null : state?.comp_id;

  const classes = Styles()



  const TipoCompe = (x) => {

    let data = x[0].disciplina_id
    let resu = "N/C"
    if (data == 1) { resu = "FORMAS" }
    if (data == 2) { resu = "LUCHA LIBRE" }
    if (data == 3) { resu = "ROTURA de POTENCIA" }
    if (data == 4) { resu = "SALTO" }

    return resu

  }




  const asignarllaves = (d) => {

    if (d[0].tipo_compe == 1) {
      return (<EliminacionDirecta llave={d} compId={compId} ancho={(x) => setMedidas(x)} />)
    }

    if (d[0].tipo_compe == 2) {
      return (<Grupos llave={d} compId={compId} ancho={(x) => setMedidas(x)} />)
    }
    if (d[0].tipo_compe == 3) {
      return (<Salto llave={d} compId={compId} ancho={(x) => setMedidas(x)} />)
    }
    if (d[0].tipo_compe == 4) {
      return (<Salto llave={d} compId={compId} ancho={(x) => setMedidas(x)} />)
    }
  }
  return (

    <div className={classes.root}>
      <div className={classes.bg} />
      <div className={classes.content}>
        <div className={classes.header}>
          <img className={classes.logologo} onClick={() => navigate(-1)} src={logoSC} alt='' />
          <Typography className={classes.disciplina}>{TipoCompe(datos)}</Typography>
        </div>

        <div className={classes.llavesScroll}>
          {datos.length > 0 ? <>
            {asignarllaves(datos)}
          </>
            : <>
              <CircularProgress style={{ color: "#39ff14" }} />
            </>
          }
        </div>
      </div>
    </div>
  );
}

export default LlavesHome;
